import React from 'react';
import { Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';

const PatientSummary = ({ patient }) => {
  const { t } = useTranslation();

  return (
    <Descriptions
      size="small"
      column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
      contentStyle={{ wordBreak: 'break-word' }}
    >
      <Descriptions.Item label={t('patient_form.fields.gender')}>
        {patient.getGender()}
      </Descriptions.Item>
      <Descriptions.Item label={t('patient_form.fields.email')}>
        {patient.getEmail()}
      </Descriptions.Item>
      <Descriptions.Item label={t('patient_form.fields.dob')}>
        {patient.getDOB()}
      </Descriptions.Item>
      <Descriptions.Item label={t('patient_form.fields.mobile_number')}>
        {patient.getMobileNumber()}
      </Descriptions.Item>
      <Descriptions.Item label={t('patient_form.fields.location')}>
        {patient.getLocation()}
      </Descriptions.Item>
      <Descriptions.Item label={t('patient_form.fields.id')}>
        {patient.getExternalId()}
      </Descriptions.Item>
      <Descriptions.Item label={t('patient_form.fields.link')} span={2}>
        {patient.getLinkElement()}
      </Descriptions.Item>
      <Descriptions.Item label={t('patient_form.fields.comments')} span={2}>
        {patient.getComments()}
      </Descriptions.Item>
    </Descriptions>
  );
};

export default PatientSummary;